// extracted by mini-css-extract-plugin
export const active = "navigation-module--active--b0vrV";
export const navigation = "navigation-module--navigation--2uvjZ";